import { Component, Input, ElementRef, AfterContentInit } from '@angular/core';

let uniqueId = 0;

@Component({
  selector: 'sui-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrl: './slide-toggle.component.scss',
})
export class SlideToggleComponent implements AfterContentInit {
  @Input() label?: string;
  @Input() type: 'boxFirst' | 'labelFirst' = 'labelFirst';
  @Input() theme: 'black' | 'blue' = 'black';

  private _id?: string;

  constructor(private _element: ElementRef) {}

  get id(): string | undefined {
    return this._id;
  }

  ngAfterContentInit(): void {
    const checkbox = this._element.nativeElement.querySelector(
      'input[type="checkbox"]'
    );

    if (!checkbox.id) {
      checkbox.id = `sui-checkbox-${uniqueId++}`;
    }

    this._id = checkbox.id;
  }

  // 부모요소에서 click 이벤트가 발생할 때
  onToggleClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    // input 자체에 클릭 => 무시
    if (target.tagName.toLowerCase() === 'input') {
      return;
    }

    const checkbox = this._element.nativeElement.querySelector(
      'input[type="checkbox"]'
    );

    if (checkbox) {
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
